// extracted by mini-css-extract-plugin
export default {"questions-cont":"QuestionNode_questions-cont__LrkGw","question":"QuestionNode_question__-ymVH","svg":"QuestionNode_svg__cwz7E","placeholder":"QuestionNode_placeholder__R-QAK"};